import { cn } from "@/lib/utils";

import { LogoIcon } from "./LogoIcon";

type Props = {
  className?: string;
};

const LogoBase: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={cn("relative size-auto", className)}
      viewBox="0 0 1473 365"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.5 55.5C11.5 46.1112 19.1112 38.5 28.5 38.5L216.497 38.5C229.831 38.5 236.537 54.5954 227.148 64.0627L38.8604 253.913C28.8002 264.056 11.5 256.932 11.5 242.646V55.5Z" />
      <path d="M137.239 198.541C144.355 191.384 155.964 191.476 162.966 198.745L264.157 303.787C272.723 312.679 266.421 327.5 254.074 327.5H47.4749C33.242 327.5 26.0936 310.31 36.1295 300.218L137.239 198.541Z" />
      <path d="M346.5 75.5H310V292H346.5V249.5L385 215L431 292H473.5L412.5 191.5L478.5 132.5H431L346.5 208V75.5Z" />
      <path d="M893 75.5H856.5V292H893V249.5L931.5 215L977.5 292H1020L959 191.5L1025 132.5H977.5L893 208V75.5Z" />
      <path d="M559.5 126.5C614 126.5 645.5 163.66 645.5 209.5C645.5 255.34 612 292.5 559.5 292.5C508.5 292.5 473.5 255.34 473.5 209.5C473.5 163.66 505 126.5 559.5 126.5ZM560 153.5C526.73 153.5 507.5 178.572 507.5 209.5C507.5 240.428 528.866 265.5 560 265.5C592.049 265.5 612.5 240.428 612.5 209.5C612.5 178.572 593.27 153.5 560 153.5Z" />
      <path d="M1111.5 126.5C1166 126.5 1197.5 163.66 1197.5 209.5C1197.5 255.34 1164 292.5 1111.5 292.5C1060.5 292.5 1025.5 255.34 1025.5 209.5C1025.5 163.66 1057 126.5 1111.5 126.5ZM1112 153.5C1078.73 153.5 1059.5 178.572 1059.5 209.5C1059.5 240.428 1080.87 265.5 1112 265.5C1144.05 265.5 1164.5 240.428 1164.5 209.5C1164.5 178.572 1145.27 153.5 1112 153.5Z" />
      <rect x="671.5" y="131.5" width="36" height="161" />
      <path d="M761.5 161.5C737.1 162.7 715.333 186 707.5 197.5V163.5C729.1 138.3 756.833 130.667 768 130H780C819.6 131.2 831.167 174.833 832 196.5L833.5 292H797.5V220.5C797.5 207.3 795.833 192.667 795 187C794 178 785.9 160.3 761.5 161.5Z" />
      <circle cx="1214" cy="278" r="14.5" />
      <circle cx="1416" cy="89" r="14.5" />
      <path d="M1328 130C1367.5 130 1383 166 1383 181V294.5H1367.5V265.5C1354.3 288.3 1336 294.5 1319 294.5H1299.5C1267 294.5 1250.5 267.5 1250.5 253.5V243.5C1251.5 216.5 1279 203 1297.5 203H1366V181C1366 152.5 1338.67 144.333 1327 143.5H1309.5C1287 143.5 1271 156.833 1262.5 164.5L1255 152.5C1273 135.7 1295.5 130 1308 130H1328ZM1296.5 215.5C1286.5 215.5 1265.1 225.8 1265.5 249C1265.9 272.2 1287 281.5 1298.5 281.5H1322.5C1333.5 281.5 1361.5 268.5 1367 247V215.5H1296.5Z" />
      <rect x="1408.5" y="129.5" width="16" height="163" />
    </svg>
  );
};

export const Logo = Object.assign(LogoBase, { Icon: LogoIcon });
